import React, { memo } from 'react';
export function FeaturesSection() {
  return <section className="w-full bg-gray-50 py-20" data-id="element-924">
      <div className="container mx-auto px-6" data-id="element-925">
        <h2 className="text-3xl font-normal text-black mb-16" data-id="element-926">
          Lo que más significa para tu marca
        </h2>
        <p className="text-base text-gray-700 mb-10 leading-relaxed max-w-3xl" data-id="element-927">
          <span className="font-medium text-black" data-id="element-928">
            Autenticidad sin filtro:
          </span>{' '}
          el barro en los zapatos y la calma en la mente después de un sendero
          largo. Una comunidad que se involucra, que busca lugares y mensajes
          que les hagan sentir vivos. Y contenido que muestra cómo tu marca
          puede ser parte de un viaje que deja huella por fuera… y por dentro.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-929">
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-930">
            <h3 className="text-xl font-normal text-black mb-4" data-id="element-931">
              Contenido Auténtico
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-932">
              Historias contadas con honestidad y cuidado. Experiencias reales
              que hacen que la gente no solo mire, sino que quiera ser parte de
              ellas.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-933">
            <h3 className="text-xl font-normal text-black mb-4" data-id="element-934">
              Audiencia Comprometida
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-935">
              Una comunidad que comenta, pregunta y participa. Personas que se
              inspiran y actúan después de ver un video o una publicación.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-936">
            <h3 className="text-xl font-normal text-black mb-4" data-id="element-937">
              Destinos Únicos
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-938">
              Lugares que sorprenden: montañas que parecen postales, caminos que
              invitan a descubrir y paisajes que se quedan grabados en la
              memoria.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-939">
            <h3 className="text-xl font-normal text-black mb-4" data-id="element-940">
              Calidad Profesional
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-941">
              Imágenes y videos que transmiten más de lo que las palabras
              pueden. Cada toma hecha con la intención de que tu marca se vea y
              se sienta en su mejor versión.
            </p>
          </div>
        </div>
      </div>
    </section>;
}